import shopifyHtmxDefaults from '../shopify-htmx/config.js';

export default {
  ...shopifyHtmxDefaults,
  includes: ['shopify-generic', 'shopify-htmx'],
  Widgets: [
    ...shopifyHtmxDefaults.Widgets,
    {
      name: 'WheelTireVehicleInfo',
      location: { insertBefore: '#shopify-section-x-results', class: 'cm_wheel-tire-vehicle-info' },
      template: 'fitmentSearch/wheelTireVehicleInfo',
    },
  ],
};
